import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';

const UserInfoAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
// MainTransferID	
// UserID	
// TransferDate	
// FromShopID	
// ToShopID
  
  const [inputProps, setInputProps] = useState({
  
    UserID:{name: 'UserID',   value: props.UserID || '' ,enabled:false},
    UserName:{name: 'UserName',   value: props.UserName || '' },
    UserFullName:{name: 'UserFullName',   value: props.UserFullName || '' },
    UserPassword:{name: 'UserPassword',  caption:'Password' , value: props.UserPassword || '' },
    });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.UserID, setInputProps },ColumnSize:0},

    {Input: TextComponent,Props: {...inputProps.UserName,setInputProps },ColumnSize:6},
    {Input: TextComponent,Props: {...inputProps.UserFullName,setInputProps },ColumnSize:6},
    {Input: TextComponent,Props: {...inputProps.UserPassword,setInputProps },ColumnSize:12},
  ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`User ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default UserInfoAdd;
